import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useNavigate, useLocation } from "react-router-dom";
import Toolbar from "../../componentes/toolbar/Toolbar";
import RenderTooltipCustom from "../../componentes/RenderTooltipCustom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RenderDateCustom from "../../componentes/RenderDateCustom";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerSolicitudes,
  setMessageError,
  setSolicitudDetalle,
  setSolicitudes,
  validarReservaExistente,
} from "../../sliceRedux/Reserva.slice";
import RenderToast from "../../componentes/RenderToast";
import moment from "moment";

const Solicitudes = () => {
  const toast = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const { datos } = location.state || {};
  const navigate = useNavigate();
  const [bandejaSolicitudes, setBandejaSolicitudes] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const listaSolicitudes = useSelector((state) => state.reserva.listaSolicitudes);
  const messageError = useSelector((state) => state.reserva.messageError);
  const solicitudDetalle = useSelector((state) => state.reserva.solicitudDetalle);
  const habilitarNuevo = bandejaSolicitudes.some(
    (item) => item.nemEstadoSolicitud === "ENREV" || item.nemEstadoSolicitud === "APRS"
  );
  useEffect(() => {
    showLoader();
    dispatch(obtenerSolicitudes(datos?.idTipoIdentificacion, datos?.identificacion));
  }, []);

  useEffect(() => {
    if (listaSolicitudes.code === 200) {
      setBandejaSolicitudes(listaSolicitudes?.object ?? []);
    }

    return () => {
      hideLoader();
      dispatch(setSolicitudes({ ...listaSolicitudes, ...{ code: 0 } }));
    };
  }, [listaSolicitudes.code]);

  useEffect(() => {
    if (solicitudDetalle.code === 200) {
      navigate("/solicitudes/nuevo", { state: { datos: datos } });
    }
    return () => {
      hideLoader();
      dispatch(setSolicitudDetalle({ ...solicitudDetalle, ...{ code: 0 } }));
    };
  }, [solicitudDetalle.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  const renderHeader = (
    <div className="flex justify-content-between">
      Solicitudes de Reserva de Denominación
      <IconField iconPosition="left">
        <InputIcon className="pi pi-search" />
        <InputText value={globalFilter} onChange={(e) => buscar(e)} placeholder="Buscar..." />
      </IconField>
    </div>
  );

  const buscar = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    if (value === "") {
      setBandejaSolicitudes([...(listaSolicitudes?.object ?? [])]);
      return;
    }

    const filtro = listaSolicitudes?.object?.filter((item) => {
      const fecEnvio = item.fecEnvio ? moment(item.fecEnvio).format("DD/MM/YYYY hh:mm:ss") : "";

      return (
        item.numSolicitud?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomCatTipoCaja?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomVinculoComun?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomParticular?.toUpperCase().includes(value.toUpperCase()) ||
        item.nomEstadoSolicitud?.toUpperCase().includes(value.toUpperCase()) ||
        fecEnvio.includes(value)
      );
    });

    setBandejaSolicitudes(filtro);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  const actionTemplate = (rowData) => {
    return (
      <>
        <Button
          icon="pi pi-file"
          rounded
          className="mr-2"
          tooltip="Revisar"
          tooltipOptions={{ position: "top" }}
          onClick={() =>
            navigate("/solicitudes/revisar", {
              state: {
                datos: datos,
                codSolReservaDenominacion: rowData.codSolReservaDenominacion,
              },
            })
          }
        />
      </>
    );
  };

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <div className="flex justify-content-between align-items-center">
            <div className="flex">
              <Button
                icon="pi pi-file-o"
                disabled={habilitarNuevo}
                className="mr-2"
                label="Nueva solicitud"
                onClick={() => {
                  showLoader();
                  let data = {
                    numIdentificacion: datos?.identificacion,
                    idTipoIdentificacion: datos?.idTipoIdentificacion,
                  };
                  dispatch(validarReservaExistente(data));
                }}
              />
            </div>
          </div>
        </Toolbar>
        <DataTable
          header={renderHeader}
          className="p-datatable-responsive-demo"
          paginator
          rows={10}
          dataKey="codSolReservaDenominacion"
          loading={undefined}
          value={bandejaSolicitudes}
          emptyMessage="Sin registros que mostrar."
          columnResizeMode="fit"
          style={{ width: "100%", overflow: "auto!important" }}
        >
          <Column
            body={rowIndexTemplate}
            header="Nro."
            sortable
            sortField="codProceso"
            headerStyle={{ textAlign: "center" }}
            style={{ width: "3%" }}
            bodyStyle={{
              textAlign: "center",
            }}
          />
          <Column
            field="numSolicitud"
            header="Solicitud"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nomCatTipoCaja"
            header="Tipo caja"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.nomCatTipoCaja)}
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nomVinculoComun"
            header="Tipo de vínculo común"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.nomVinculoComun)}
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="nomParticular"
            header="Nombre particular"
            sortable
            body={(rowData) => RenderTooltipCustom(rowData.nomParticular)}
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            field="fecEnvio"
            header="Fecha envío"
            sortable
            headerStyle={{ textAlign: "center" }}
            body={(rowData) => RenderDateCustom(rowData.fecEnvio, 1)}
            bodyStyle={{ textAlign: "center", color: "hsl(206deg 100% 43%)" }}
          />
          <Column
            field="nomEstadoSolicitud"
            header="Estado"
            sortable
            headerStyle={{ textAlign: "center" }}
          />
          <Column
            header="Acciones"
            headerStyle={{ textAlign: "center" }}
            bodyStyle={{
              textAlign: "center",
            }}
            body={actionTemplate}
          ></Column>
        </DataTable>
      </div>
    </>
  );
};
export default Solicitudes;
